import VueI18n from '@/setup/i18n'
import { SnotifyPosition } from 'vue-snotify'

VueI18n.setLocaleMessage('en-US', {
  'delete_confirm_title': 'Are you sure?',
  'confirm_yes': 'Yes',
  'confirm_no': 'No'
})

VueI18n.setLocaleMessage('pt-BR', {
  'delete_confirm_title': 'Tem certeza?',
  'confirm_yes': 'Sim',
  'confirm_no': 'Não'
})

export default (message, callbackTrue, callbackFalse, $snotify) => {
  $snotify.warning(
    message,
    VueI18n.t('delete_confirm_title'),
    {
      position: SnotifyPosition.centerCenter,
      showProgressBar: false,
      closeOnClick: false,
      backdrop: 0.65,
      icon: false,
      timeout: 0,
      buttons: [
        {
          text: VueI18n.t('confirm_yes'),
          action: callbackTrue,
          bold: true
        },
        {
          text: VueI18n.t('confirm_no'),
          action: callbackFalse
        }
      ]
    }
  )
}
